import ApiCore from './api-core'
import { PUBLIC } from '@/constants/api-types'

export default class PublicAccount extends ApiCore {
  constructor(store) {
    const path = `${PUBLIC}/account`

    super(store, path)
  }

  driverRegister(model, showProgress) {
    return this.request({
      action: 'register/driver',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  check(model, showProgress) {
    return this.request({
      action: 'check',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  login(model, showProgress) {
    return this.request({
      action: 'login',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  otpLogin(model, showProgress) {
    return this.request({
      action: 'otp/login',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  otpPassword(model, showProgress) {
    return this.request({
      action: 'otp/password/old',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
